import React from 'react';
import img from '../images/services/custom.jpg'; 
import img2 from '../images/services/offset.jpg';
import img3 from '../images/services/luxury-finish.jpg';
import img4 from '../images/services/die-cut-lamination.jpg';

const Services = () => {

    return (
        <div id="services" className="bg-gray-100 py-12" >
            <section data-aos="zoom-in-down">
                    <div className="my-4 py-4">
                        <h2 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">our services</h2>
                        <div className='flex justify-center'>
                            <div className='w-24 border-b-4 border-blue-900'></div>
                        </div>
                        <h2 className="mt-4 mx-12 text-center text-s lg:text-2xl font-semibold text-blue-900">We provide end-to-end packaging and printing solutions tailored for cosmetic, healthcare, and lifestyle businesses — from concept to carton.</h2>
                    </div>

                    <div className="px-12" data-aos="fade-down" data-aos-delay="600">
                        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
                            {[{
                                img: img,
                                title: "Custom Packaging Design",
                                desc: "We help you conceptualize and structure your packaging with expert dieline creation, branding alignment, and material recommendations — ensuring visual appeal and functionality."
                            }, {
                                img: img2,
                                title: "Offset Printing Solutions",
                                desc: "Using Heidelberg 2C, 4C, and 6C presses, we offer sharp, vibrant, and color-consistent printing on paper and board — perfect for mono cartons, inserts, and labels."
                            }, {
                                img: img3,
                                title: "Luxury Finishing",
                                desc: "Enhance your packaging with foiling, UV, embossing, debossing, lamination, and texture coatings. These finishes increase shelf impact and customer engagement."
                            }, {
                                img: img4,
                                title: "In-House Die-Cutting & Lamination",
                                desc: "All critical processes like die-cutting, folding, lamination, and window patching are handled in-house for complete control, consistency, and timely delivery."
                            }].map((service, idx) => (
                                <div key={idx} className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:bg-gray-500 hover:text-white rounded-lg shadow-2xl p-3 group">
                                    <div className="m-2 text-justify text-sm">
                                        <img alt="card img" src={service.img} className="h-48 w-full object-cover rounded-t group-hover:scale-[1.15] transition duration-1000 ease-in-out" />
                                        <h2 className="font-semibold my-4 text-2xl text-center">{service.title}</h2>
                                        <p className="text-md font-medium">{service.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
            </section>

            <section>
                <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6">
                    <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left" data-aos="zoom-out">
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <div className='text-blue-900 mb-4'>
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-14 h-14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-4a2 2 0 012-2h16a2 2 0 012 2v4a2 2 0 01-2 2h-2m-4 0h-4" />
                                </svg>
                            </div>
                            <h3 className="text-3xl text-blue-900 font-bold">We <span className='font-black'>Build</span></h3>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>
                                With decades of technical know-how and investment in German and Japanese print technologies, we create premium packaging that speaks your brand's language — clean, durable, and distinguished.
                            </p>
                        </div>
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <div className='text-blue-900 mb-4'>
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-14 h-14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a4 4 0 00-4-4h-1m-4 6h1v-2a4 4 0 00-3-3.87M7 20h1v-2a4 4 0 00-3-3.87M7 4a2 2 0 110 4 2 2 0 010-4zm10 0a2 2 0 110 4 2 2 0 010-4zM7 12a4 4 0 100-8 4 4 0 000 8z" />
                                </svg>
                            </div>
                            <h3 className="text-3xl text-blue-900 font-bold">We <span className='font-black'>Collaborate</span></h3>
                            <p className='my-3 text-xl text-gray-600 font-semibold'>Whether you’re a startup brand or an established FMCG giant, we work closely with your marketing and product teams to ensure the packaging not only protects but also sells. We're not just printers — we're your packaging partner.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Services;